import React, { Component, ReactInstance } from 'react';
import { assert } from 'ts-essentials';
import { getTemplateInfos } from '@com-pc/template-recommendation/utils';
import VIP_IMG from '@src/framework/editor/src/img/pageIndex/toolbar/vip-dimond.svg';
import styles from './recommend.css';
import { isSVip, isVip } from '@src/js/common/ark-extensions/dc-components/vip-linktext';
import { openPay } from '@src/js/common/ark-extensions/dc-components/pay';
import { getAidForReport } from '@tencent/txdocs-aid';
import { tdw } from '@src/slide/infrastructure/module/dependent/report/offline-data-report/tdw-report';
import { IUiDataService } from '@src/slide/domain/ui-model/service/ui-data-service.interface';
import { IEditorAppServices } from '@src/slide/application/entry/toc/editor/base/base-editor-app-service.interface';
import { AppServiceProvider } from '@src/slide/application/app-service-provider';
import {
    TDWActionType,
    TDWModuleType,
    TDWOperationType,
} from '@src/slide/infrastructure/module/dependent/report/offline-data-report/constant';
import { findDOMNode } from 'react-dom';
import { importSlidesV3, updatePresentationBySelectedV3 } from '@com-pc/paging-selection/utils';
import { SlideDataServices } from '@src/slide/domain/slide-app/core/slide-data-services.core';
import { IPresentationDataModel } from '@tencent/slide-sdk-model';

const CUSTOM_TEMPLATE = 2;
const TemplateType = {
    PaymentByPrice: 0, // 仅仅看价格
    LimitedFree: 1, // 限定条件的免费
    FreeForVIP: 2, // 会员免费
    NeedVIPAndPay: 3, // 需要会员付费才能使用
    Free: 4, // 免费
    FreeForsuperVIP: 5, // 超级会员免费
    ChargedByusage: 6, // 按使用次数计费
    InAppPurchased: 7, // 应用内含付费
    NoRequirementType: 10, // 无类型，仅用于筛选
};

// 上报用
const getReportVipType = (type) => {
    switch (type) {
        case TemplateType.FreeForVIP:
            return 1;
        case TemplateType.Free:
            return 2;
        case TemplateType.ChargedByusage:
            return 3;
        case TemplateType.FreeForsuperVIP:
            return 4;
        default:
            return 0;
    }
};

// 上报用
export const getReportSourceType = (tabId) => {
    switch (tabId) {
        case 'cover':
            return 8001;
        case 'contents':
            return 8002;
        case 'chapter':
            return 8003;
        case 'text':
            return 8004;
        case 'end':
            return 8005;
        default:
            return 0;
    }
};

const LIMITED_FREE_IMG = 'https://vfiles.gtimg.cn/vupload/20210311/6f9da01615450074300.svg';
const SVIP_IMG = 'https://docs.gtimg.com/tmall/image/svip_tag-2ce6af3082.svg';
interface IProps {
    item: {
        authorId: string;
        id: string;
        itemId: string;
        metaOfEachType: string;
        name: string;
        source: number;
        topicId: string;
        tabId: string;
        requirements: {
            type: number;
        };
    };
    containerRef: ReactInstance;
    handleClickCB?: () => void;
}

export default class RecommendAddItem extends Component<IProps> {
    private metaData: {
        images: {
            mobile_thumb_2x: { url: string };
            pc_thumb_2x: { url: string };
            pc_preview: { url: string };
        };
    };
    private isFree = false;
    private imgRef: React.RefObject<HTMLImageElement>;
    private observer: IntersectionObserver;

    public constructor(props: IProps) {
        super(props);
        this.metaData = JSON.parse(props.item.metaOfEachType);
        this.isFree = props.item.requirements.type === TemplateType.Free;
        this.imgRef = React.createRef();
    }

    public componentDidMount = () => {
        this.observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        this.reportOnImgShow();
                    }
                });
            },
            {
                // eslint-disable-next-line react/no-find-dom-node
                root: findDOMNode(this.props.containerRef) as Element,
                rootMargin: '4px',
                threshold: 0,
            },
        );

        if (this.imgRef.current) {
            this.observer.observe(this.imgRef.current);
        }
    };

    public render() {
        const { images } = this.metaData;
        return (
            <div className={styles['recommend-item']}>
                <img
                    ref={this.imgRef}
                    className={styles['recommend-img']}
                    src={images.pc_thumb_2x?.url || images.pc_preview?.url}
                    width="128"
                    height="72"
                    alt=""
                    onClick={this.onClick}
                />
                {!this.isFree ? <img src={this.getIconSrc()} className={styles['recommend-icon']} /> : null}
            </div>
        );
    }

    private getIconSrc = () => {
        switch (this.props.item.requirements.type) {
            case TemplateType.LimitedFree:
                return LIMITED_FREE_IMG;
            case TemplateType.FreeForVIP:
                return VIP_IMG;
            case TemplateType.FreeForsuperVIP:
                return SVIP_IMG;
            default:
                return LIMITED_FREE_IMG;
        }
    };

    private onClick = () => {
        const { id, name, topicId, tabId } = this.props.item;
        // 商城上报 模板商城-模板内容-模板点击使用（点击缩略图时上报）
        tdw({
            opername: TDWOperationType.DOC_TEMPLATE_WEB,
            module: TDWModuleType.TEMPLATE_ITEM,
            action: TDWActionType.TEMPLATE_CLICK,
            ver6: id, // 模板id
            ver7: name, // 模板名称
            ver8: topicId, // topicId
            ver11: 2, // 缩略图点击
            ver12: 1, // 模板商城模板
            file_type: 4, // ppt
            source3: 'doc_ppt_recommend_reco', // fromPage
            ver9: 'doc_ppt_recommend_reco', // fromPage
            ver5: getReportSourceType(tabId), //
        });
        const requireType = this.props.item.requirements.type;
        if (
            (requireType === TemplateType.FreeForVIP && !isVip())
            || (requireType === TemplateType.FreeForsuperVIP && !isSVip())
        ) {
            this.vipGuide();
            return;
        }
        this.addTemplateV3();
    };

    private addTemplateV3 = async () => {
        const presentationStr = await getTemplateInfos(this.props.item.id, this.props.item.source === CUSTOM_TEMPLATE);
        assert(presentationStr, 'presentationStr is empty');
        const presentationStoreService = SlideDataServices.SDKDataServices.PresentationStoreService();
        assert(presentationStoreService, 'PresentationStoreService is not ready');
        const isV3Data = !presentationStr.includes('slideWidth');
        const importPresentationStoreService = isV3Data
            ? presentationStoreService.createFromSlideFileData(JSON.parse(presentationStr))
            : presentationStoreService.createFromOldPresentationData(presentationStr);
        const importPresentation = importPresentationStoreService.getPresentation();
        const presentation = this.getUiDataService().presentation.sdkData as IPresentationDataModel;
        await updatePresentationBySelectedV3(presentation, importPresentation, importPresentation.slideList, true);
        importSlidesV3(importPresentation.getWritableOwnedData(), this.props.handleClickCB, true);
        importPresentationStoreService.dispose();
        // 上报 幻灯片列表-选择模板添加页面成功
        tdw({
            opername: TDWOperationType.DOC_PPT,
            module: TDWModuleType.PC_EDIT_LIST,
            action: TDWActionType.ADD_TEM_SUC,
        });
    };

    private vipGuide = () => {
        const aid = getAidForReport({
            position: 'slideaddpage',
            feature: 'template',
        });
        openPay(aid);
    };

    private reportOnImgShow = () => {
        const { requirements, id, name, topicId, tabId } = this.props.item;
        // 商城上报 模板商城-模板商城页-模板缩略图曝光
        tdw({
            opername: TDWOperationType.DOC_TEMPLATE_WEB,
            module: TDWModuleType.TEMPLATE_MALL,
            action: TDWActionType.TEMP_LATE_UPV,
            ver6: id, // 模板id
            ver7: name, // 模板名称
            ver8: topicId, // topicId
            ver11: getReportVipType(requirements?.type), // vip，免费，按条，SVIP
            ver12: 1, // 模板商城模板
            file_type: 4, // ppt
            source3: 'doc_ppt_recommend_reco', // fromPage
            ver9: 'doc_ppt_recommend_reco', // fromPage
            ver5: getReportSourceType(tabId), // fromPage
        });
    };

    private getUiDataService(): IUiDataService {
        return this.getAppServices().getUiDataService();
    }
    private getAppServices(): IEditorAppServices {
        return AppServiceProvider.getInstance().getAppServices() as
            IEditorAppServices;
    }
}
